module.exports = __webpack_public_path__ + "img/dak-installatie-zonnepanelen.ab586a69.jpg";